export const STATE_OPTIONS = [
  { id: 'AL-US', fullName: "Alabama", abbreviation: "AL", country: "US" },
  { id: 'AK-US', fullName: "Alaska", abbreviation: "AK", country: "US" },
  { id: 'AZ-US', fullName: "Arizona", abbreviation: "AZ", country: "US" },
  { id: 'AR-US', fullName: "Arkansas", abbreviation: "AR", country: "US" },
  { id: 'CA-US', fullName: "California", abbreviation: "CA", country: "US" },
  { id: 'CO-US', fullName: "Colorado", abbreviation: "CO", country: "US" },
  { id: 'CT-US', fullName: "Connecticut", abbreviation: "CT", country: "US" },
  { id: 'DE-US', fullName: "Delaware", abbreviation: "DE", country: "US" },
  { id: 'DC-US', fullName: "District of Columbia", abbreviation: "DC", country: "US" },
  { id: 'FL-US', fullName: "Florida", abbreviation: "FL", country: "US" },
  { id: 'GA-US', fullName: "Georgia", abbreviation: "GA", country: "US" },
  { id: 'HI-US', fullName: "Hawaii", abbreviation: "HI", country: "US" },
  { id: 'ID-US', fullName: "Idaho", abbreviation: "ID", country: "US" },
  { id: 'IL-US', fullName: "Illinois", abbreviation: "IL", country: "US" },
  { id: 'IN-US', fullName: "Indiana", abbreviation: "IN", country: "US" },
  { id: 'IA-US', fullName: "Iowa", abbreviation: "IA", country: "US" },
  { id: 'KS-US', fullName: "Kansas", abbreviation: "KS", country: "US" },
  { id: 'KY-US', fullName: "Kentucky", abbreviation: "KY", country: "US" },
  { id: 'LA-US', fullName: "Louisiana", abbreviation: "LA", country: "US" },
  { id: 'ME-US', fullName: "Maine", abbreviation: "ME", country: "US" },
  { id: 'MD-US', fullName: "Maryland", abbreviation: "MD", country: "US" },
  { id: 'MA-US', fullName: "Massachusetts", abbreviation: "MA", country: "US" },
  { id: 'MI-US', fullName: "Michigan", abbreviation: "MI", country: "US" },
  { id: 'MN-US', fullName: "Minnesota", abbreviation: "MN", country: "US" },
  { id: 'MS-US', fullName: "Mississippi", abbreviation: "MS", country: "US" },
  { id: 'MO-US', fullName: "Missouri", abbreviation: "MO", country: "US" },
  { id: 'MT-US', fullName: "Montana", abbreviation: "MT", country: "US" },
  { id: 'NE-US', fullName: "Nebraska", abbreviation: "NE", country: "US" },
  { id: 'NV-US', fullName: "Nevada", abbreviation: "NV", country: "US" },
  { id: 'NH-US', fullName: "New Hampshire", abbreviation: "NH", country: "US" },
  { id: 'NJ-US', fullName: "New Jersey", abbreviation: "NJ", country: "US" },
  { id: 'NM-US', fullName: "New Mexico", abbreviation: "NM", country: "US" },
  { id: 'NY-US', fullName: "New York", abbreviation: "NY", country: "US" },
  { id: 'NC-US', fullName: "North Carolina", abbreviation: "NC", country: "US" },
  { id: 'ND-US', fullName: "North Dakota", abbreviation: "ND", country: "US" },
  { id: 'OH-US', fullName: "Ohio", abbreviation: "OH", country: "US" },
  { id: 'OK-US', fullName: "Oklahoma", abbreviation: "OK", country: "US" },
  { id: 'OR-US', fullName: "Oregon", abbreviation: "OR", country: "US" },
  { id: 'PA-US', fullName: "Pennsylvania", abbreviation: "PA", country: "US" },
  { id: 'RI-US', fullName: "Rhode Island", abbreviation: "RI", country: "US" },
  { id: 'SC-US', fullName: "South Carolina", abbreviation: "SC", country: "US" },
  { id: 'SD-US', fullName: "South Dakota", abbreviation: "SD", country: "US" },
  { id: 'TN-US', fullName: "Tennessee", abbreviation: "TN", country: "US" },
  { id: 'TX-US', fullName: "Texas", abbreviation: "TX", country: "US" },
  { id: 'UT-US', fullName: "Utah", abbreviation: "UT", country: "US" },
  { id: 'VT-US', fullName: "Vermont", abbreviation: "VT", country: "US" },
  { id: 'VA-US', fullName: "Virginia", abbreviation: "VA", country: "US" },
  { id: 'WA-US', fullName: "Washington", abbreviation: "WA", country: "US" },
  { id: 'WV-US', fullName: "West Virginia", abbreviation: "WV", country: "US" },
  { id: 'WI-US', fullName: "Wisconsin", abbreviation: "WI", country: "US" },
  { id: 'WY-US', fullName: "Wyoming", abbreviation: "WY", country: "US" },
  { id: 'AB-CA', fullName: "Alberta", abbreviation: "AB", country: "Canada" },
  { id: 'BC-CA', fullName: "British Columbia", abbreviation: "BC", country: "Canada" },
  { id: 'MB-CA', fullName: "Manitoba", abbreviation: "MB", country: "Canada" },
  { id: 'NB-CA', fullName: "New Brunswick", abbreviation: "NB", country: "Canada" },
  { id: 'NL-CA', fullName: "Newfoundland and Labrador", abbreviation: "NL", country: "Canada" },
  { id: 'NT-CA', fullName: "Northwest Territories", abbreviation: "NT", country: "Canada" },
  { id: 'NS-CA', fullName: "Nova Scotia", abbreviation: "NS", country: "Canada" },
  { id: 'NU-CA', fullName: "Nunavut", abbreviation: "NU", country: "Canada" },
  { id: 'ON-CA', fullName: "Ontario", abbreviation: "ON", country: "Canada" },
  { id: 'PE-CA', fullName: "Prince Edward Island", abbreviation: "PE", country: "Canada" },
  { id: 'QC-CA', fullName: "Quebec", abbreviation: "QC", country: "Canada" },
  { id: 'SK-CA', fullName: "Saskatchewan", abbreviation: "SK", country: "Canada" },
  { id: 'YT-CA', fullName: "Yukon", abbreviation: "YT", country: "Canada" },
] as const;